(function () {
  if (window.__ptDiamond) return; window.__ptDiamond = 1;
  function emit(n, p) { try { if (window.traxEmit) window.traxEmit(n, p); } catch (e) {} }
  function slot(el) { var c = el.closest('[data-ph]'); return c ? c.getAttribute('data-ph') : ''; }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ptd]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/^(sms|tel):/.test(href) || /direct\.lc\.chat/.test(href)) return;
    var h = slot(a);
    emit('select_promotion', { promotion_id: 'diamond-' + a.getAttribute('data-ptd'), promotion_name: h + '|' + (a.getAttribute('data-pn') || ''),
      creative_slot: h, link_url: href || location.pathname });
  }, true);
  var bs = document.querySelectorAll('.ptd[data-ptv]');
  if (!bs.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) {
      if (!es[i].isIntersecting) continue;
      var t = es[i].target, v = t.getAttribute('data-ptv'), h = t.getAttribute('data-ph') || '';
      io.unobserve(t);
      emit('view_promotion', { promotion_id: 'diamond-' + v, promotion_name: v === 'ladder' ? h : h + '|' + v, creative_slot: h, link_url: location.pathname });
    }
  }, { threshold: 0.25 });
  for (var i = 0; i < bs.length; i++) io.observe(bs[i]);
})();
